import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AdminAction } from 'src/app/models/adminaction.model';
import { SchoolModuleBatch, SchoolModuleEvent } from 'src/app/models/module/moduledetails';
import { ComponentheaderService } from 'src/app/services/componentheader.service';
import { ModulemanagementService } from 'src/app/services/modules/modulemanagement.service';
import { ClassmanagementService } from 'src/app/services/classmanagement.service';
import { TableColumn } from 'src/app/reuseableui/tablelayout/tablelayout.component';
import { delay } from 'rxjs';

declare const $: any;

@Component({
  selector: 'app-modulestudentlist',
  templateUrl: './modulestudentlist.component.html',
  styleUrls: ['./modulestudentlist.component.css'],
})
export class ModulestudentlistComponent implements OnInit {
    
  p: number = 1;
  students: any;
  stats: any;
  itemsPerPage = 25;
  totalItems: any;
  data: any;
  moduleid: number;
  allowBatches: false;
  moduleBatches: SchoolModuleBatch[] = [];
  batchFilterActions: AdminAction[] = [];
  count: number;
  //filteredStudents: any[];
  //activeFilterId: number = 0;
  filterOptions: any;
  columns: TableColumn[] = [];
  removeColumn = ["count", "passed", "completedLessons", "studentId"];
  selectedBatchId: number = 0;
  schdata: any;
  adminActions: AdminAction[] = [];
  noStudentText = "No students enrolled";
  moduleStats: any;
  summaryCards: Array<any> = [];
  overviewLead: any = null;
  lessonStat: any;
  isLessonStatLoading: boolean;
  @ViewChild('actionslink') actionsLink: ElementRef;
  filterValues = [['All Lessons Passed','passed', 'var(--success-soft)'], ['Yet to pass', 'nopass', 'var(--warn-soft)'], ['Course marked as completed', 'completed', 'var(--info-soft)'], 
              ['Some lessons completed' ,'somelessonscompleted', 'var(--info-soft)'], ['All lessons incomplete', 'nostart', 'var(--danger-soft)']];

  constructor(
    public modulemanager: ModulemanagementService,
    public toastr: ToastrService,
    public headerinfo: ComponentheaderService,
    public router: ActivatedRoute,
    public route: Router,
    public classservice: ClassmanagementService
    ) 
  {
      headerinfo.setHeaderDisplay(`Course Students List`, [], []);
      this.moduleid = this.router.snapshot.queryParams.moduleid; 
      this.modulemanager.getModuleStudentsStat(this.moduleid).subscribe(
        (res) => {
          this.moduleStats = res;
          this.buildOverview();
        }
      );
  }
    
  /**
   * Builds the summary cards from the stat summary.
   *
   * The labels describe students, not lessons, because that is what the figures count —
   * "1" here means one student, not one lesson.
   */
  buildOverview() {
    const active = this.moduleStats.activeStudentsCount;
    const atLeastOne = this.moduleStats.numberOfStudentsWithAtLeastOneCompleteLesson;
    const completed = this.moduleStats.totalStudentsCompleted;
    const passed = this.moduleStats.totalStudentsPassed;
    const notPassed = this.moduleStats.totalStudentNotPassed;
    const allLessonsIncomplete = active - atLeastOne;

    // Lead tile: the two context figures plus an exact started / not-started split.
    const pct = (n: number) => active > 0 ? Math.round((n / active) * 100) : 0;
    this.overviewLead = {
      lessons: this.moduleStats.totalLessons,
      active,
      started: atLeastOne,
      notStarted: allLessonsIncomplete,
      startedPct: pct(atLeastOne),
    };

    // Outcome tiles. Tone carries meaning: green for the two positive outcomes, amber and
    // red for the two that need attention. Labels and notes are unchanged.
    this.summaryCards = [
      { label: 'Completed the Course', value: completed, note: 'Marked as complete',
        icon: 'fas fa-check-circle', tone: 'green', pct: pct(completed) },
      { label: 'All Lessons Passed', value: passed, note: 'Met the pass mark',
        icon: 'fas fa-award', tone: 'green', pct: pct(passed) },
      { label: 'Yet to Pass', value: notPassed, note: 'Started but not passed',
        icon: 'fas fa-hourglass-half', tone: 'amber', pct: pct(notPassed) },
      { label: 'Not Started', value: allLessonsIncomplete, note: 'No lesson completed yet',
        icon: 'fas fa-exclamation-circle', tone: 'red', pct: pct(allLessonsIncomplete) },
    ];
  }

  async ngOnInit() {
    this.headerinfo.pageLoadingStarted(this);
    this.adminActions.push({displaytext: 'Export all students', callback: this.export.bind(this), classes: ['fas', 'fa-cloud-download-alt']});   
    this.headerinfo.setHeaderDisplay(
      `Course Students`,
      [
        {
          displaytext: 'School',
          route: `/user/schoolhome`,
          //params: { moduleID: this.moduleid },
        },
        {
          displaytext: 'Course',
          route: `/user/moduledetails`,
          params: { moduleID: this.moduleid },
        },
        {
          displaytext: `Registered Students`,
          route: `/user/modulestudentlist`,
          params: this.router.snapshot.queryParams,
        },
      ],
      this.adminActions
    );
    this.headerinfo.pageLoadingDone(this);
  }

  export() {
    // this.modulemanager.downloadModuleStudentList(this.moduleid).subscribe();
    this.headerinfo.pageLoadingStarted(this);
    try {

    this.modulemanager
    .downloadModuleStudent(this.moduleid)
    .subscribe((response: any) => {
      const url = window.URL.createObjectURL(response);
      window.open(url);

    }),
    (error: any) => console.log('Error downloading the file'),
    () => console.info('File downloaded successfully');
    } catch (error) {

    }finally{
      this.headerinfo.pageLoadingDone(this);
    }
  }

  async loadTableData(eventData){
    try{
      this.headerinfo.pageLoadingStarted(this);
      this.schdata = await this.modulemanager.getModuleDetails(this.moduleid).toPromise();

      this.allowBatches = this.schdata?.allowBatches;
      if (this.allowBatches){
        this.moduleBatches = await this.modulemanager.getModuleBatches(this.moduleid).toPromise();
  
        let defaultBatchAction = new AdminAction();
        defaultBatchAction.displaytext = "All Batches";
        defaultBatchAction.params = {id: 0}
        this.batchFilterActions.push(defaultBatchAction);
        this.moduleBatches.forEach(b => {
          let obj = new AdminAction();
          obj.displaytext = b.name;
          obj.params = {id: b.id};
          if (!this.batchFilterActions.find(a => a.displaytext == b.name))
            this.batchFilterActions.push(obj);
        });
      };

      this.data = await this.modulemanager
        .getModuleStudents(this.moduleid, eventData.page, eventData.offset, this.setFilterData(eventData), eventData.sortBy, eventData.sortAscending)
        .toPromise()
        .catch((err) => {
          this.toastr.error(err);
          this.route.navigate(['/user/moduledetails'], {
            queryParams: { moduleID: this.moduleid },
          });
          return;
        })
        .finally(() => this.headerinfo.pageLoadingDone(this));      
      this.setResult(eventData);               
    }
    catch(e){
      console.log(e)
    }
    finally{
      this.headerinfo.pageLoadingDone(this);
    }
  }
  setResult(eventData) {
    // The endpoint now returns { students, columns } rather than a bare array —
    // column order and headers used to be inferred from the property names.
    this.students = this.data?.students ?? [];
    this.columns = this.data?.columns ?? [];
    this.students.length > 0 ? this.count = this.students[0].count : 0;
    eventData.filters?.length > 0 ? this.filterOptions = eventData.filters : this.loadFilterOptions();
  }
  setFilterData(eventData) {
    let filterParams = [];

    if (eventData?.filters) {
      for (let f of eventData.filters) {
        //get dropdown values
        if (f["value"] && (f["dropdown"] == true || f["search"] == true))
          filterParams.push({ value: f["value"], param: f["param"] });
        //get datetime values
        else if (f["value"] && f["date"] == true)
          filterParams.push({ value: new Date(f["value"]).toISOString(), param: f["param"] });        
      }
    }

    return filterParams;
  }
  loadFilterOptions() {
    this.filterOptions = new Array();
    this.filterOptions.push(
      {
        param: 'Search',
        search: true,      
        label: 'Search',
      }
    )
    this.filterOptions.push(
      {
        param: 'Filter',
        dropdown: true,
        date: false,
        label: "Filter By",
        dropdownOptions: this.filterValues.map(item => {
          return {
            displaytext: item[0].toUpperCase(),
            value: item[1],
            bgcolor: item[2]
          }
        })
      },
    )
    if(this.schdata?.allowBatches){
      this.filterOptions.push(       
        { param: 'Batch', dropdown: true, date: false,
          label: "Batch", dropdownOptions: this.batchFilterActions.map(item => {
            return { displaytext: item.displaytext, value: item.params.id }})
        },
      );
    }    
  }
  async rowClicked(event){
    try{
      $('#lessonstatmodal').modal('show');    
      this.isLessonStatLoading = true;
      this.lessonStat = await this.modulemanager.getStudentModuleStats(this.moduleid, event['studentId']).toPromise();
    }
    finally{
      this.isLessonStatLoading = false;
    }    
  }

  hasAnyLessonStarted(lessons: any){    
    return lessons?.some(l => l.completed);
  }
}
